import { UserManagementAccountUsersQuery } from '__generated__/atlas-types'

export type AccountUser =
  UserManagementAccountUsersQuery['activeViewingAccount']['accountUsers']['edges'][number]['node']

export enum Statuses {
  ACTIVE = 'Active',
  DISABLED = 'Disabled',
}

export enum Actions {
  REASSIGN = 'REASSIGN',
  REMOVE = 'REMOVE',
}
